import{__exports as e}from"../../../../../_virtual/common.js";var o,T;o=e,Object.defineProperty(o,"__esModule",{value:!0}),o.TokenType=void 0,(T=o.TokenType||(o.TokenType={})).ERC20="ERC20",T.ERC721="ERC721",T.NATIVE_TOKEN="NATIVE_TOKEN";
